import { ALL_DAY_PERIOD } from './timingConstants'
import { formatMinutesAsTime, getDayOffset, parseTimeToMinutes } from './timingUtils'

const DAYS = ['Lu', 'Ma', 'Mi', 'ju', 'vi', 'Sa', 'Do']
const END_OF_DAY = '23:59'

const emptyPeriods = () => ({
  period1: [],
  period2: [],
  auxPeriod: [],
  auxPeriod2: [],
  auxDays: undefined
})

const shiftSelectedDays = (selectedDays, dayOffset) =>
  DAYS.reduce((shiftedDays, day, index) => {
    if (!selectedDays?.[day]) return shiftedDays

    const shiftedIndex = (index + dayOffset + DAYS.length) % DAYS.length
    shiftedDays[DAYS[shiftedIndex]] = true
    return shiftedDays
  }, {})

const convertSlotToUtcPeriods = (startHour, endHour, offset) => {
  const localStart = parseTimeToMinutes(startHour)
  const localEnd = parseTimeToMinutes(endHour)
  const numericOffset = Number(offset)

  if (
    localStart === null ||
    localEnd === null ||
    localStart >= localEnd ||
    !Number.isFinite(numericOffset)
  ) {
    return null
  }

  const utcStart = localStart + numericOffset
  const utcEnd = localEnd + numericOffset
  const startDay = getDayOffset(utcStart)
  const endDay = getDayOffset(utcEnd)

  if (startDay === endDay) {
    if (startDay === 0) {
      return {
        period: [formatMinutesAsTime(utcStart), formatMinutesAsTime(utcEnd)],
        auxPeriod: [],
        auxDayOffset: 0
      }
    }
    if (Math.abs(startDay) === 1) {
      return {
        period: [...ALL_DAY_PERIOD],
        auxPeriod: [formatMinutesAsTime(utcStart), formatMinutesAsTime(utcEnd)],
        auxDayOffset: startDay
      }
    }
    return null
  }

  if (startDay === -1 && endDay === 0) {
    return {
      period: ['00:00', formatMinutesAsTime(utcEnd)],
      auxPeriod: [formatMinutesAsTime(utcStart), END_OF_DAY],
      auxDayOffset: -1
    }
  }

  if (startDay === 0 && endDay === 1) {
    return {
      period: [formatMinutesAsTime(utcStart), END_OF_DAY],
      auxPeriod: ['00:00', formatMinutesAsTime(utcEnd)],
      auxDayOffset: 1
    }
  }

  return null
}

const getAlertTimingPeriods = ({
  firstStartHour,
  firstEndHour,
  secondStartHour,
  secondEndHour,
  typeCheckedBox,
  secondOccupationHoursChecked,
  offset
}) => {
  const periods = emptyPeriods()
  const firstSlot = convertSlotToUtcPeriods(firstStartHour, firstEndHour, offset)
  if (!firstSlot) return periods

  periods.period1 = firstSlot.period
  periods.auxPeriod = firstSlot.auxPeriod

  let auxDayOffset = firstSlot.auxDayOffset

  if (secondOccupationHoursChecked) {
    const secondSlot = convertSlotToUtcPeriods(secondStartHour, secondEndHour, offset)
    if (secondSlot) {
      periods.period2 = secondSlot.period
      periods.auxPeriod2 = secondSlot.auxPeriod
      auxDayOffset = auxDayOffset || secondSlot.auxDayOffset
    }
  }

  if (auxDayOffset) {
    periods.auxDays = shiftSelectedDays(typeCheckedBox, auxDayOffset)
  }

  return periods
}

export default getAlertTimingPeriods
